import { useEffect } from "react";
import arogyaBeeDoctorProLogo from "../../assets/svg/arogya-bee-doctor-pro-logo.jpg";
import "../QRArogyaBee/QRArogyaBee.css";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.ehs.arogyabeepro";

const QRArogyaBeeDoctorPro = () => {
  useEffect(() => {
    window.location.href = PLAY_STORE_URL;
  }, []);

  return (
    <div className="qr-redirect-body">
      <img
        src={arogyaBeeDoctorProLogo}
        alt="ArogyaBee Doctor Pro Logo"
        className="qr-app-logo"
      />
      <h1 className="qr-app-name">ArogyaBee Doctor Pro</h1>
      <p className="qr-redirect-msg">
        Redirecting you to the Play Store&hellip;
        <br />
        If the redirect doesn&apos;t open automatically, tap the button below.
      </p>
      <a href={PLAY_STORE_URL} className="playstore-btn" target="_blank" rel="noreferrer">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.18 23.76c.3.17.64.24.99.2L15.9 12 12.06 8.16 3.18 23.76z" />
          <path d="M22.03 10.27 19.2 8.7l-3.54 3.3 3.54 3.3 2.86-1.6a1.75 1.75 0 0 0 0-3.43z" />
          <path d="M2.01.54A1.74 1.74 0 0 0 1.5 1.8v20.4c0 .46.18.87.51 1.17l.06.05 11.43-11.43v-.27L2.07.49l-.06.05z" />
          <path d="M15.9 12 12.06 8.16l-9.87-7.62A1.76 1.76 0 0 1 3.18.3L15.9 12z" />
        </svg>
        View in Play Store
      </a>
    </div>
  );
};

export default QRArogyaBeeDoctorPro;
